// frontend/src/Homr.js
import React from 'react';
import FireWorks from './FireWorks'; // Importer le composant FireWorks
import PieChartComponent from './PieChartComponent';
import { useTranslation } from 'react-i18next';
import '../css/Home.css';

const Home = () => {
  const { t } = useTranslation();

  return (
    <div className="home-container">
      <h1 className="rainbow-title">
        <span className="white-text">
          {t('home.title')}
        </span>
      </h1>         
      <h2>{t('home.message1')}</h2>
      <h2>{t('home.message2')}</h2>

      <div className="pie-chart">
        <PieChartComponent />
      </div>
      <FireWorks />  
    </div>
  );
};

export default Home;
